import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[var(--legatum-text-muted)]">
        <div className="flex items-center gap-3" data-testid="auth-checking">
          <div className="h-2 w-2 rounded-full bg-[var(--legatum-gold)] animate-pulse" />
          <span className="text-sm tracking-wide">Verificando sesión…</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
